//#region [IMPORT]

import React, { useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';

import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Tooltip,
} from '@mui/material';

import { WidthFull, WidthNormal } from '@mui/icons-material'

// === COMPONENTS ===
import { toBoolean } from 'components/utils';
import { Spacer } from 'components/Spacer';
import Styled from 'components/Styled/Styled';

//#endregion

//-----------------------------------------------------------------
export function ControlBanner( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { onChange } = props;

  const theme = useTheme()

  let is_magnifier_held_default = toBoolean( localStorage.getItem( 'image-magnifier-hold' ) );

  const [ is_full_size      , setIsFullSize      ] = useState( true  );
  const [ is_magnifier_held , setIsMagnifierHeld ] = useState( false );
  const [ magnifier_size    , setMagnifierSize   ] = useState( 100   );

  const settings = {
    is_full_size,
    is_magnifier_held,
    magnifier_size,
  }
    
  //#endregion

  //#region [STYLES]
  
  const _bg_pd_blue     = {background  : theme.palette.primary.main}
  const _bg_secondary   = {background  : theme.palette.background.secondary[theme.palette.mode]}
  const _color_pd_blue  = {color       : theme.palette.primary.main}
  const _border_pd_blue = {borderColor : theme.palette.primary.main}
  const _border_bottom  = {borderBottom:'4px solid'}
  const _no_shrink      = {flexShrink:0}
  const _pointer        = {cursor: 'pointer'};
  const _size_30px      = {height:'30px', width:'30px'}
  const _flex           = {display:'flex'}
  const _center_items   = { justifyContent: 'center', alignItems: 'center'}

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    const is_full_size_default      = toBoolean( localStorage.getItem( 'image-size' ) );
    const is_magnifier_held_default = toBoolean( localStorage.getItem( 'image-magnifier-hold' ) );
    const magnifier_size_default    = +( localStorage.getItem( 'image-magnifier-size' ) ) || 100;
    setIsFullSize( is_full_size_default );
    setIsMagnifierHeld( is_magnifier_held_default );
    setMagnifierSize( magnifier_size_default )

    onChange?.({
      is_full_size      : is_full_size,
      is_magnifier_held : is_magnifier_held_default,
      magnifier_size    : magnifier_size_default
    });

  }, [onChange] )

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function toggleImageSize() {
    //-----------------------------------------------------------------
    setIsFullSize ((prev) => !prev)
    localStorage.setItem( 'image-size', !is_full_size );
    onChange?.({...settings, is_full_size: !is_full_size });
  }
  
  //-----------------------------------------------------------------
  function onChange_MagnifierHeld( event ) {
    //-----------------------------------------------------------------
    setIsMagnifierHeld(event.target.checked)
    localStorage.setItem( 'image-magnifier-hold', event.target.checked );
    onChange?.({...settings, is_magnifier_held: event.target.checked });
  }
  
  //-----------------------------------------------------------------
  function onChange_MagnifierSize( event ) {
    //-----------------------------------------------------------------
    const number = Number(event.target.value);
    if (0 <= number && number <= 999) {
      setMagnifierSize( number );
      localStorage.setItem( 'image-magnifier-size', number );
      onChange?.({...settings, magnifier_size: number });
    }
  }
    
  //-----------------------------------------------------------------
  function onMouseUp_Size(event) {
    //-----------------------------------------------------------------
    event.stopPropagation();
    event.preventDefault();
  }

  //#endregion 

  //#region [RENDER]
  
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[_flex,{height:'60px'},_bg_secondary, _center_items]} >
        <Styled styles={[ _flex, _center_items]}>
          {SizeControl()}
          <Spacer width='25px' />
          <Divider orientation="vertical" flexItem sx={{height: '90%', borderRightWidth: 2, ..._border_pd_blue } } />
          <Spacer width='25px' />
          Magnifier:
          <Spacer />
          {MagnifierSize()}
          <Spacer />
          {MagnifierHoldToggle()}
        </Styled>
      </Styled>
    )
  }

  //-----------------------------------------------------------------
  function SizeControl() {
    //-----------------------------------------------------------------
    const tooltip_text = is_full_size ? 'Fit Page' : 'Fit Width';
    const width_icon   = is_full_size ? <WidthNormal fontSize="large" /> : <WidthFull fontSize="large" />
    return (
      <Tooltip title={tooltip_text}>
        <Styled styles={[_size_30px, _no_shrink, _color_pd_blue, _pointer]} onClick={toggleImageSize} >
          {width_icon}
        </Styled>
      </Tooltip>
    )
  }

  //-----------------------------------------------------------------
  function MagnifierSize() {
    //-----------------------------------------------------------------
    return (
      <FormControl sx={{ m: 1, width: '84px',..._no_shrink }} variant="outlined">
        <InputLabel htmlFor="magnifier-size-input">Size</InputLabel>
        <OutlinedInput
          id="magnifier-size-input"
          value={magnifier_size}
          size='small'
          label='Size'
          onChange={onChange_MagnifierSize}
          onMouseUp={onMouseUp_Size}
          endAdornment={<InputAdornment position="end">%</InputAdornment>}
        />
      </FormControl>
    )
  }

  //-----------------------------------------------------------------
  function MagnifierHoldToggle() {
    //-----------------------------------------------------------------
    return (
      <FormControlLabel
        label   = "Keep maintained"
        control ={<Checkbox defaultChecked={is_magnifier_held_default} onChange={onChange_MagnifierHeld}/>}
      />
    )
  }

  //#endregion
  
  return display();
}